export default function AdminDetailDrawer({ title, onClose, children }) {
  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-40" onClick={onClose} />
      <div className="fixed top-0 right-0 h-full w-full max-w-2xl bg-white z-50 shadow-2xl overflow-y-auto animate-fade-in">
        <div className="sticky top-0 bg-white border-b border-vault-border px-6 py-4 flex items-center justify-between z-10">
          <h2 className="font-heading text-xl text-vault-navy">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>
        <div className="p-6">
          {children}
        </div>
      </div>
    </>
  );
}
